export const localeMapping: { [key: string]: string } = {
  au: 'en-AU',
  nz: 'en-NZ',
};
